import { render } from "./MenuBar.vue?vue&type=template&id=843aef22&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=843aef22&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-843aef22"]])

export default __exports__